import { put, call, select, takeEvery } from 'redux-saga/effects'
import { get, isEmpty } from 'lodash'

import {
  addToUnsyncedOrderList,
  saveOrder,
  START_CASH_ORDER,
  syncOrderFailed,
  syncOrderInitiated,
  syncOrderRequested,
  syncOrderSucceeded,
  mutationRequested,
  mutationSucceeded,
  mutationFailed,
} from '../../actions/order'
import { clearRemoteOrderTotal } from '../../actions/orderTotalRemote'
import MutationApi from '../../remote/mutationApi'
import Log from '../../utils/Log'

import { createOrder } from '../../models/order/create'
import { getFinalOrderState, makeGetOrder, getCurrentOrderId } from '../../selectors/order'
import { makeGetCartItems } from '../../selectors/cart'

import Stadium from '@ordernext/networking-stadium/stadium'
import { toast } from 'react-toastify'

import { customHistory } from '../../stores'

const getOrder = makeGetOrder()

const directTo = (method = 'push', path) => {
  if (path === undefined) return

  customHistory[method](path)
}
export function* syncCashOrder(params = {}) {
  const order = yield select(state => getOrder(state, params.id))
  const { uuid: orderId } = order
  const syncedOrder = {
    ...order
  }

  const closePayload = {
    orderId
  }
 
  try {
    const result = yield call(Stadium.createPosOrder, order.createOrderParams)
    yield put(syncOrderSucceeded(result, syncedOrder))
    if (result?.status === 201) {
      try {
        yield put(mutationRequested({ orderId, mutationType: 'close' }))
        const result = yield call(MutationApi.closeTabOrder, closePayload)
        yield put(mutationSucceeded({ orderId }))
        
        const applied = result?.data?.orderMutations?.[0]?.applied
        if (applied) {
          yield call(directTo, 'push', `/receipt/${orderId}`)
          yield put(clearRemoteOrderTotal())
        } else {
          yield call(directTo, 'push', `/tabs/${orderId}`)
          Log.error('Close Tab With New Cash Failed', { orderId, closePayload })
        }
      
      } catch (err) {
        yield put(mutationFailed({ orderId }))
        yield call(directTo, 'push', `/tabs/${orderId}`)
        Log.error('Close Tab With New Cash Failed', { orderId, closePayload })
      }
    
    }
  } catch (err) {
    yield put(syncOrderFailed(err, syncedOrder))
    const currentOrderId = yield select(getCurrentOrderId)
    if (syncedOrder?.uuid === currentOrderId) {
      const errorMessage = err?.response?.data?.errorMessage ?? "An error occured with order sync"
      toast.error(`${errorMessage}`, { autoClose: false })
    }

    throw err
  }
}


export function* startCashOrder(params = {}) {
  const finalOrderState = yield select(getFinalOrderState)
  const getCartItems = makeGetCartItems()
  const lineItems = yield select(getCartItems)
  // const orderId = get(params, 'payload.orderId', '')

  const args = {
    exemptionOverrides: get(params, 'payload.exemptionOverrides'),
    userNotes: params?.payload?.userNotes ?? null,
    paymentCompleted: true,
    paymentDisplay: 'Cash',
    paymentType: 'cash',
    state: finalOrderState,
  }
  if (isEmpty(lineItems)) {
    yield call(directTo, 'push', '/tab-order')
    toast.error("Orders must have at least one associated item")
    return
  }
  const order = yield createOrder(args)

  if (order.remoteOrderTotal.failed) {
    toast.error("Order Creation Failed")
    return
  }

  const { uuid } = order

  yield put(saveOrder(order))
  yield put(addToUnsyncedOrderList(uuid))
  yield put(syncOrderInitiated(uuid))

  try {
    yield syncCashOrder({ id: uuid })
  } catch (err) {
    yield call(directTo, 'push', `/tabs/${uuid}`)
  }
}

export function* watchStartCashOrder() {
  yield takeEvery(START_CASH_ORDER, startCashOrder)
}
